import { getApiUrl } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const TERMS_URL_TRANSLATION_KEY =
  Resources.Onboarding.Steps.PersonalInformation.StardustParticipation.LinkUrl;

/** Absolute URL of the Stardust program terms PDF (served by the API, one path per language). */
export const useStardustTermsUrl = () => {
  const { t } = useResource();

  return `${getApiUrl()}${t(TERMS_URL_TRANSLATION_KEY)}`;
};
